import React from "react";
import ListTable from "../../../Components/Table/ListTable";
import UserInvitationsTableRow from "./UserInvitationsTableRow";
import { useTranslation } from "../../../context/Internationalization";

const schema = (t) => [
  {
    id: 'from',
    label: t('from').charAt(0).toUpperCase() + t('from').slice(1),
    sortable: false,
    minWidth: 180,
  },
  {
    id: 'to',
    label: t('to').charAt(0).toUpperCase() + t('to').slice(1),
    sortable: false,
    minWidth: 180,
  },
  {
    id: 'referenceTo',
    label: t('referenceTo'),
    sortable: false,
    minWidth: 200,
  },
  {
    id: 'status',
    label: t('status'),
    sortable: false,
    minWidth: 140,
  },
  {
    id: 'type',
    label: t('type'),
    sortable: false,
    minWidth: 180,
  },
]

const UserInvitationsTable = ({ data = [], menuActions = [], lastElementRef, emptyMessage }) => {
  const { t } = useTranslation();
  const rowElement = (dato, index) => <UserInvitationsTableRow
      key={dato._id}
      lastElementRef={lastElementRef}
      data={dato}
      index={index}
      menuActions={menuActions}
  />

  return (
    <ListTable
      rows={data}
      columns={schema(t)}
      rowElement={rowElement}
      tableAriaLabel={t('user_invitations')}
      minWidth={880}
      emptyMessage={emptyMessage}
    />
  );
};

export default UserInvitationsTable;
